// import logo from '../mlogo.svg'
import React, { useEffect, useState, useRef } from 'react'

import Container from 'react-bootstrap/Container'
import { Toast } from 'react-bootstrap';
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'
import Modal from 'react-bootstrap/Modal'
import { AudioConfig, SpeechConfig, SpeechRecognizer } from 'microsoft-cognitiveservices-speech-sdk'

import stopBtn from './images/stopBtnV2.png'
import startBtn from './images/startBtnV2.png'
import logoImgLeft from '../logo.png'
import logoTextB from '../logoTextB.png'
// import LoginPop from './LoginPop'
import avatar from '../avatar.png'
import vip1 from './images/vip1.png'
import vip2 from './images/vip2.png'
import vip3 from './images/vip3.png'
import Userpage from './Userpage'
import { useUserAuth } from "../context/UserAuthContext";
import e from 'cors'
import { Link, useLocation } from 'react-router-dom';
import TextToSpeech from './TextToSpeech';

import MicRecorder from 'mic-recorder-to-mp3';
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import toWav from 'audiobuffer-to-wav';

import { set } from 'react-hook-form'
import { GPT_KEYWORDS, GPT_PRE_KEYWORDS, INTERFACE_CONTENT_TEXT, GPT_PROMPT_CONTENT } from './Keywords';
import History from './History';
import Notedetail from './Notedetail';
import LoadingAnimation from './LoadingAnimation'
import axios from 'axios';
import { CSSTransition } from 'react-transition-group';
import SettingsPopup from './SettingsPopup'
import PricePopup from './PricePopup'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
// import { Toast } from 'primereact/toast';
import CongratulationsPopup from './checkout/Congratulations'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faChevronUp, faChevronDown, faCog, faQuestionCircle, faHome, faToggleOn, faPlay, faPause, faLifeRing, faLevelUpAlt, faQuestion, faSignature, faMicrophone, faStop, faFileExport, faICursor, faRocket, faMousePointer, faTimes, faSignOutAlt, faCodeBranch, faHistory, faPencilAlt, faKey, faGlobe, faFileAudio, faList } from '@fortawesome/free-solid-svg-icons';
import FaqsPopup from './FaqsPopup'
import WavRecorder from './recorder/WavRecorder'

// import SignIn from './SignIn'

// import Recorderfunc from './Recorderfunc'
// import eventEmitter from './EventEmitter';

// import { useDispatch, useSelector } from 'react-redux';
// import { startTranscription, stopTranscription, saveTranscription } from './actions/transcriptionActions';

// const API_KEY = process.env.REACT_APP_COG_SERVICE_KEY
// const API_LOCATION = process.env.REACT_APP_COG_SERVICE_LOCATION
// const speechConfig = SpeechConfig.fromSubscription(API_KEY, API_LOCATION)
// speechConfig.speechRecognitionLanguage = "en-US" 



let confirmDisplayed = false;
let countFetch = 0
let freshPageCount = 0
// recognizer must be a global variable
let recognizer
// let transcriber = null;
let callGptByKeywordstemp = true;
// let inputValueTemp = '';
// let inputValueYouSayTemp = '';
// let responseTextTemp = '';
// let textValueTempFlag = false;
let startBtnManualClicked = false;
let userTypingTextYouSay = false;
let userTypingText = false;
let askAll = false;

const Mp3Recorder = new MicRecorder({
  bitRate: 128,
  prefix: "data:audio/wav;base64,",
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}


function SuperuserTranscribeForever() {

  const sdk = require("microsoft-cognitiveservices-speech-sdk")
  const [recognisedText, setRecognisedText] = useState("")
  const [recognisedTextYouSay, setRecognisedTextYouSay] = useState("")
  const [recognisingText, setRecognisingText] = useState("")
  const [recognisingTextYouSay, setRecognisingTextYouSay] = useState("")
  const [responseText, setResponseText] = useState("")
  const [audioDetected, setAudioDetected] = useState(false)

  const [isRecognising, setIsRecognising] = useState(false)
  const [isAIthinking, setIsAIthinking] = useState(false)
  const [isPaused, setIsPaused] = useState(false)
  const [stopBtnClicked, setStopBtnClicked] = useState(false)
  const responseTextRef = useRef()
  const textRef = useRef()
  const textRefYouSay = useRef()

  const timeoutRef = useRef(null)

  const startStopRecordingRef = useRef(null)
  const canvasRef = useRef(null)
  const recordingStartTimeRef = useRef(null)
  let audioContext, analyser, microphone, animationFrameId
  const mediaStreamRef = useRef(null)
  const [showPopup, setShowPopup] = useState(false)
  const [showHistoryPopup, setShowHistoryPopup] = useState(false)
  const [showSettingsPopup, setShowSettingsPopup] = useState(false)

  // const [showTestOnePopup, setShowTestOnePopup] = useState(false)   //need delete
  // const [showTestTwoPopup, setShowTestTwoPopup] = useState(false)   //need delete
  
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [showLoginPopup, setShowLoginPopup] = useState(true)
  const [userInfoAppPage, setUserInfoAppPage] = useState(null)
  const [inputValue, setInputValue] = useState('');
  const [inputValueYouSay, setInputValueYouSay] = useState('');
  const [audioStream, setAudioStream] = useState(null);
  const [audioContextForRecorder, setAudioContextForRecorder] = useState(null);

  // const [recordingStatusSet, setRecordingStatusSet] = useState(false)
  // const dispatch = useDispatch();
  
  const [isRecording, setIsRecording] = useState(false);

  const [isBlocked, setIsBlocked] = useState(false);
  const downloadLink = useRef(null);
  const [startRecordClicked, setStartRecordClicked] = useState(false);
  const [stopRecordClicked, setStopRecordClicked] = useState(false);
  const [saveRecordClicked, setSaveRecordClicked] = useState(false);
  const [avatarNow, setAvatarNow] = useState(avatar);
  const [showSpeechToText, setShowSpeechToText] = useState(false);
  const query = useQuery();
  const [audioBlob, setAudioBlob] = React.useState(null);
  const [blobURL, setBlobURL] = useState('');
  const [selectedNote, setSelectedNote] = useState(null);
  const [userDataChangedAppPage, setUserDataChangedAppPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [showPricePopup, setShowPricePopup] = useState(false);
  // const toast = useRef(null);
  const [usageOverMaxset, setUsageOverMaxset] = useState(false);
  const [needUpgradeUserLevel, setNeedUpgradeUserLevel] = useState(false);
  const [userInforChangedByUserDataLocal, setUserInforChangedByUserDataLocal] = useState(false);
  const [loadingText, setLoadingText] = useState('Loading ...');
  const [usingTime, setUsingTime] = useState(null);
  const [keywordsPreCallGpt, setKeywordsPreCallGpt] = useState(GPT_PRE_KEYWORDS['en-US']);
  const [keywordsCallGpt, setKeywordsCallGpt] = useState(GPT_KEYWORDS['en-US']);
  const [showCongratulationsPopup, setShowCongratulationsPopup] = useState(false);

  const [vipLevelString, setVipLevelString] = useState('Free User');
  const [upgradeBtnTitle, setUpgradeBtnTitle] = useState('Get Nvoice VIP');
  const [usageStatus, setUsageStatus] = useState('10% used');
  const [usageMax, setUsageMax] = useState('10% used');
  const [usageTime, setUsageTime] = useState('10% used');
  const [expireTime, setExpireTime] = useState();
  const [showFaqsPopup, setShowFaqsPopup] = useState(false);
  const [showSTTPopup, setShowSTTPopup] = useState(false);
  const [showTTSPopup, setShowTTSPopup] = useState(false);


  const [showSoundSignatureWavrecorder, setShowSoundSignatureWavrecorder] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [voiceSignatureStrings, setVoiceSignatureStrings] = useState([]);
  const [currentSpeaker, setCurrentSpeaker] = useState('');
  const [transcriber, setTranscriber] = useState(null);

  const [showSelectTextPopup, setShowSelectTextPopup] = useState(false);
  const [showSelectTextIntervieweePopup, setShowSelectTextIntervieweePopup] = useState(false);
  const [mouseDownLetInputValueSelectTextBeTop, setMouseDownLetInputValueSelectTextBeTop] = useState(false);
  const [mouseDownLetInputValueYouSaySelectTextBeTop, setMouseDownLetInputValueYouSaySelectTextBeTop] = useState(false);
  const [selectTextPopupPosition, setSelectTextPopupPosition] = useState({ top: 50, left: 50 });
  const [selectedText,setSelectedText] = useState('');
  const [callGptByKeywords, setCallGptByKeywords] = useState(true);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const [modeTitle, setModeTitle] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][0]); //AI changes everything, AI achieves everything
  const [interviewerTitle, setInterviewerTitle] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][1]);
  const [interviewerTranscriptPlaceholdText, setInterviewerTranscriptPlaceholdText] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][2]);
  const [aiResponseTitle, setAiResponseTitle] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][3]);
  const [aiResponsePlaceholdText, setAiResponsePlaceholdText] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][4]);
  const [intervieweeTitle, setIntervieweeTitle] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][5]);
  const [intervieweeTranscriptPlaceholdText, setIntervieweeTranscriptPlaceholdText] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][6]);

  const [isLeftPanelVisible, setIsLeftPanelVisible] = useState(true);
  const [isTranscriptPanelVisible, setIsTranscriptPanelVisible] = useState(true);
  const [logoSrc, setLogoSrc] = useState(logoTextB);
  const [needLogin, setNeedLogin] = useState(false);
  const [userDataLocal, setUserDataLocal] = useState(null);
  const [promptInput, setPromptInput] = useState('');

  useEffect(() => {
    // 在窗口即将关闭时注销用户
    if(userDataLocal === null || userDataLocal === 'null') setIsLoading(true);
    // window.addEventListener('beforeunload', logOut);
    // // 在组件卸载时移除事件监听器

    function handleResize() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
      setLogoSrc((window.innerWidth <= 800 || isMobile) ? logoImgLeft : logoTextB);
      if(window.innerWidth <= 800 || isMobile) {
        setIsLeftPanelVisible(false);
      } else {
        setIsLeftPanelVisible(true);
      }
      if(window.innerWidth >= 800) {
        setLogoSrc(logoTextB)
      }

      if(isMobile){
        document.querySelector('.appstyle-right-panel').style.gridTemplateRows = '7% 74% 19%';
      } else {
        document.querySelector('.appstyle-right-panel').style.gridTemplateRows = '7% 84% 9%';
      }

      if (isRecognising) {
        if(isMobile){
          document.querySelector('.appstyle-footer').style.padding = '0px 15px 60px 0px';
        } else {
          document.querySelector('.appstyle-footer').style.padding = '10px 15px 10px 0';
        }
      } else {
        if(isMobile){
          document.querySelector('.appstyle-footer').style.padding = '0px 15px 50px 0px';
        } else {
          document.querySelector('.appstyle-footer').style.padding = '20px 15px 10px 0';
        }
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    let newUserRecord = {
      Name: "SuperUser",
      Email: 'superuser@vip.com',
      Usage: {
        time: 0,
        tokenusage: 0
      },
      VIPLevel: 2,
      Keywords: [],
      Language: {
        lan: "English",
        code: "en-US"
      },
      GPTVersion: "GPT-4o",
      GPTPromptContent:"You are a virtual employee of SpringAI LLC. Your name is Spring. Your company dedicated to providing big data and AI service to the world.",
      AudioSet: "mp3",
      SummarySet: [],
      SummaryLength: "Brief",
      History: [],
    };

    setUserDataLocal(newUserRecord);

    return () => {
    //   window.removeEventListener('beforeunload', logOut);
    //   logOut(); 
      window.removeEventListener('resize', handleResize);
    
      if (transcriber) {
        transcriber.stopTranscribingAsync();
        transcriber.close();
        setTranscriber(null);
      }
      if (recognizer) {
        recognizer.stopContinuousRecognitionAsync();
        recognizer.close();
        recognizer = null;
      }
    };
  }, []); 

  useEffect(() => {
    let userInput;
    while (true) {
      userInput = prompt("Please enter the passcode:");
      if (validateInput(userInput)) {
        break;
      }
    }
  }, []);
  
  function validateInput(input) {
    // 在这里添加你的验证逻辑
    // 如果输入满足条件，返回 true
    // 否则，返回 false
    if(input ==='super0521') {
      return true; }
      else {
        return false;
      }
  }

  useEffect(() => {

      setLoadingText('Done');
      setKeywordsFunc();
      setTimeout(() => {
        setIsLoading(false);
        setUserInfoAppPage(userDataLocal);
        // updateUserInformation();
      } , 600)
      setToastMessage('Data updated successfully!' );
      setShowToast(true);
  }, [userDataLocal]);

  useEffect(() => {
    let timeoutRefOne = null;
    let timeoutRefTwo = null;
    timeoutRefOne = setTimeout(() => {
      if(isLoading) {
        setLoadingText('Network error. Please try again later.');
        timeoutRefTwo = setTimeout(() => {
          if(isLoading) {
            setIsLoading(false);
          }
        } , 2000)
      }
    }, 15000)
    return () => {
      if(timeoutRefOne) {
        clearTimeout(timeoutRefOne);
      }
      if(timeoutRefTwo) {
        clearTimeout(timeoutRefTwo);
      }
    }
  }, [isLoading]);


  useEffect(() => {
    const mouseMoveHandler = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    document.addEventListener('mousemove', mouseMoveHandler);
    if(!showSelectTextPopup || callGptByKeywords) {
      document.removeEventListener('mousemove', mouseMoveHandler);
    }
    return () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
    }
  }, [selectedText]);

  useEffect(() => {
    if(askAll && selectedText !== '') {
      console.log('selectedText is:', selectedText);
      handleAskAI();
      askAll = false;
    }
  }, [selectedText, askAll]);

  useEffect(() => {
    if(!showSelectTextPopup && !callGptByKeywords) {
      setMouseDownLetInputValueSelectTextBeTop(false);
      setMouseDownLetInputValueYouSaySelectTextBeTop(false);
      setIsPaused(false);
    }else {
      //nothing
    }
  }, [showSelectTextPopup]);  // , showSelectTextIntervieweePopup] remember to add this when speaker identified funtion is added

  useEffect(() => {
    callGptByKeywordstemp = callGptByKeywords;
  }, [callGptByKeywords]);


  useEffect(() => {
    if (startRecordClicked) {
      startRecorder();
      // 根据需要重置autoStart状态
      setStartRecordClicked(false);
    }
  }, [startRecordClicked]);

  useEffect(() => {
    if (stopRecordClicked) {
      stopRecorder();
      // 根据需要重置autoStart状态
      setStopRecordClicked(false);
    }
  }, [stopRecordClicked]);

  useEffect(() => {
    if (saveRecordClicked) {
      saveRecorder();
      // 根据需要重置autoStart状态
      setSaveRecordClicked(false);
    }
  }, [saveRecordClicked]);

  useEffect(() => {
    if (userInfoAppPage) {
      resetUserInfo();
      if(!isRecognising) {
        freshPageCount = 0;
        setStopBtnClicked(false);
        // setTimeout(() => {
          setUserInforChangedByUserDataLocal(!userInforChangedByUserDataLocal);
        // }, 10);
      }

          setAvatarNow(vip2)


        setIsLoggedIn(true)

      
    } 

    // console.log('isLoggedIn:', isLoggedIn)

  }, [userInfoAppPage]);


  const setKeywordsFunc = () => {
    // console.log("userDataLocal is:", userDataLocal)
    
    let keywords = GPT_PRE_KEYWORDS[userDataLocal?.Language.code||'en-US'];
    let keywordsTwo = GPT_KEYWORDS[userDataLocal?.Language.code||'en-US'];
   
      setKeywordsPreCallGpt(keywords);
      setKeywordsCallGpt(keywordsTwo);


  }

  useEffect(() => {
    if(currentSpeaker !== 'Candidate' && !mouseDownLetInputValueSelectTextBeTop  && !userTypingText) {
      setInputValue(`${recognisedText}${recognisingText}`);
    } else if (userTypingText){
      userTypingText = false;
    }
  }, [recognisedText, recognisingText]);

  useEffect(() => {
    if(currentSpeaker === 'Candidate' && !mouseDownLetInputValueYouSaySelectTextBeTop && !userTypingTextYouSay) {
      setInputValueYouSay(`${recognisedTextYouSay}${recognisingTextYouSay}`);
    } else if (userTypingTextYouSay){
      userTypingTextYouSay = false;
    }
  }, [recognisedTextYouSay, recognisingTextYouSay]);

  useEffect(() => {
    if(userTypingText) {
      
      setRecognisedText(inputValue)
      
    }else if(userTypingTextYouSay) {
      // userTypingTextYouSay = false
      // userTypingText = false
      setRecognisedTextYouSay(inputValueYouSay)
      
    }
  }, [inputValue, inputValueYouSay]);

  

  const toggleListener = () => {
    if (!isLoggedIn) {
      setNeedLogin(true);
      window.location.href = '/login';
      } else {

          if (!isRecognising) {
            startBtnManualClicked = true;
            setStartTime(new Date());
            setIsAIthinking(false);
            setStopBtnClicked(false);
            // console.log('stopBtnClicked changed to false'); 
            if(freshPageCount === 0){
              freshPageCount++
            }
            setRecognisedText("")
            setRecognisedTextYouSay("")

            setInputValue('');
            setInputValueYouSay('');
            setResponseText('');

            setStartRecordClicked(true)
            // setTimeout(() => {
              startRecognizer()
            // }, 100)
          } else {
            setStopBtnClicked(true)
            // console.log('stopBtnClicked changed to true');
            stopRecognizer()
            setStopRecordClicked(true)
          }

      }
  }

  

  useEffect(() => {

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);

    if (isRecognising) {
      document.querySelector('.appstyle-footer').style.gridTemplateColumns = '11fr 4fr';
      if(isMobile){
        document.querySelector('.appstyle-footer').style.padding = '0px 15px 60px 0px';
      } else {
        document.querySelector('.appstyle-footer').style.padding = '10px 15px 10px 0';
      }
    } else {
      document.querySelector('.appstyle-footer').style.gridTemplateColumns = '1fr';
      if(isMobile){
        document.querySelector('.appstyle-footer').style.padding = '0px 15px 50px 0px';
      } else {
        document.querySelector('.appstyle-footer').style.padding = '20px 15px 10px 0';
      }
    }

    // console.log(' isRecognising is changeto to:', isRecognising? 'true':'false')  
    const canvas = canvasRef.current // 获取canvas元素的引用
    const startStopRecording = startStopRecordingRef.current
    let stream = null
    let streamPromise = null

    let canvasWidthTemp = 250;
    let canvasHeightTemp = 50;
    let timeLabelX = 5/6;
    
    if(window.innerWidth <= 800 || isMobile) {
      canvasWidthTemp = 200;
      canvasHeightTemp = 40;
      timeLabelX = 4/6;
    }

    if (isRecognising && canvasRef.current) {
      canvas.width = canvasWidthTemp; //250//canvasRef.current.offsetWidth; //300
      canvas.height = canvasHeightTemp; //50; //canvasRef.current.offsetHeight;  //50
      canvas.style.background = '#fffcf7';
      canvas.style.borderRadius = '10px';
      canvas.style.margin = 'auto'; 
    }

    var constraints = {
      video: false,
      audio: {
        channelCount: 1,
        sampleRate: 16000,
        sampleSize: 16,
        volume: 1
      }
    }
    // if(userInforChangedByUserDataLocal) {
      const getMedia = async (constraints) => {
        try {
          // stream = await navigator.mediaDevices.getUserMedia(constraints)
          // if (!stream && !stopBtnClicked) {
          if (!stream) {
            // console.log("getMedia running step2")
            const streamPromise = navigator.mediaDevices.getUserMedia(constraints); // 存储Promise对象
            stream = await streamPromise; // 等待获取媒体流
            mediaStreamRef.current = stream;

            //2024.05.17 mix stream_______________________________________________________


            //____________________________________________________________________________


            setAudioStream(stream);
            initAudioAnalyser(stream);
            loopDrawing(); // 在获取媒体后立即调用loopDrawing函数
            if (freshPageCount === 0 && modeTitle !== 'Interview') {
              createRecognizer(stream)
            }
            if(modeTitle === 'Interview' && transcriber===null) {
              createMeetingRecognizer(stream);
            } else if(modeTitle !== 'Interview' && transcriber!==null) {
              transcriber.stopTranscribingAsync();
              transcriber.close();
              setTranscriber(null);
            }
          }
        } catch (err) {
          /* handle the error */
          if (!isRecognising) {
            if (freshPageCount !== 0) {
              alert("Please allow the microphone permission.");
            } else {
              setToastMessage('Please allow the microphone permission.' );
              setShowToast(true);
            }
            freshPageCount=0;
            if (recognizer) stopRecognizer();
            setStopBtnClicked(false);
            setStopRecordClicked(false);
            setStartRecordClicked(false);
          }
          console.log(err)
        }
      }

      if (!stream) {
        // console.log("getMedia running step1-0 when page initialized")
        getMedia(constraints)
      }

    
      // 0227 释放麦克风权限
      // 0227

      const initAudioAnalyser = (stream) => {
        audioContext = new (window.AudioContext || window.webkitAudioContext)()
        setAudioContextForRecorder(audioContext)
        analyser = audioContext.createAnalyser()
        microphone = audioContext.createMediaStreamSource(stream)
        microphone.connect(analyser)
        analyser.fftSize = 256
      }

      const loopDrawing = () => {

        if (!isRecognising) 
        {
          return
        }
        animationFrameId = requestAnimationFrame(loopDrawing)

        const bufferLength = analyser.frequencyBinCount
        const dataArray = new Uint8Array(bufferLength)
        analyser.getByteFrequencyData(dataArray)

        const ctx = canvas.getContext('2d')
        const width = canvas.width * 7 / 8
        const height = canvas.height * 1 / 2
        const startX = canvas.width / 2 - width / 2
        const startY = canvas.height / 2 + height / 8

        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.fillStyle = '#ff4800' // fe682d 

        const barWidth = width / (bufferLength / 2);
        let barHeight;
        let x = startX;

        for (let i = 0; i < bufferLength/2; i++) {
          barHeight = dataArray[i] / 3;
          ctx.fillRect(x, startY + (height - barHeight), barWidth / 2, barHeight);
          x += barWidth;
        }

        // 计算单次录音时间
        const elapsed = Date.now() - recordingStartTimeRef.current;  
        const minutes = Math.floor(elapsed / 60000).toString().padStart(2, '0');
        const seconds = Math.floor((elapsed % 60000) / 1000).toString().padStart(2, '0');
        const timeText = `${minutes}:${seconds}`;
        ctx.font = '16px Fraunces';
        ctx.fillStyle = '#361700';
        ctx.textAlign = 'left';
        ctx.fillText(timeText, canvas.width * timeLabelX, 20);
      }

      const startStopRecordingHandler = () => {

          if (!isRecognising) {
            recordingStartTimeRef.current = Date.now();
            // setTimeout(() => {
              //nothing
              // console.log("call getMedia step1-1 in startStopRecordingHandler")
              getMedia(constraints)
            // }, 1000)
            
            
          } else {
            if (audioContext && audioContext.state !== 'closed') {
              audioContext.close()
            }
            cancelAnimationFrame(animationFrameId)

            if (mediaStreamRef.current) {
              mediaStreamRef.current.getTracks().forEach(track => track.stop()); // 停止所有轨道
              mediaStreamRef.current = null;
            }

            // console.log("Stream exists:", stream)
            if (stream) {
              // stream.getTracks().forEach(track => track.stop()) // 取消媒体流
              stream.getTracks().forEach(function(track) {
                track.stop();
              });
              stream = null; // 清除媒体流对象
            }
            // 取消请求的音频流
            if (streamPromise && streamPromise.cancel) {
                streamPromise.cancel();
            }
          }

      }
    
      startStopRecording.addEventListener('click', startStopRecordingHandler);
    //   setUserInforChangedByUserDataLocal(false);
    // }

    return () => {
      if (audioContext && audioContext.state !== 'closed') {
          audioContext.close();
        }
      cancelAnimationFrame(animationFrameId)
      // console.log('unmounting...')

      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach(track => track.stop());
      }

      if (recognizer) {
        // stopRecognizer()
        // recognizer.close();
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

    }

  }, [isRecognising, userInforChangedByUserDataLocal, modeTitle])

  // this function will create a speech recognizer based on the audio Stream
  // NB -> it will create it, but not start it
  const createRecognizer = (audioStream) => {
    
    fetch('/api/speech-config')
      .then(response => response.json())
      .then(config => {
      // 使用配置信息初始化 SpeechRecognizer
      const speechConfig = SpeechConfig.fromSubscription(config.subscriptionKey, config.serviceRegion);

      speechConfig.speechRecognitionLanguage = [userDataLocal?.Language?.code||'en-US']; 

      // configure Azure STT to listen to an audio Stream
      const audioConfig = AudioConfig.fromStreamInput(audioStream)

      // recognizer is a global variable
      if (recognizer) {
        recognizer.stopContinuousRecognitionAsync();
        recognizer.close();
        recognizer = null;
      }
      recognizer = new SpeechRecognizer(speechConfig, audioConfig)
      // recognizer = new sdk.ConversationTranscriber(speechConfig, audioConfig)

      recognizer.recognizing = (s, e) => {

        setAudioDetected(true)
        setRecognisingText(e.result.text)
        textRef.current.scrollTop = textRef.current.scrollHeight
      }

      recognizer.recognized = (s, e) => {


        setAudioDetected(false)
        setRecognisingText("")
        // timeoutRef.current = setTimeout(() => {
        //   if (!audioDetected) {
        //     // console.log("No audio detected within 30 seconds.")
        //     // stopRecognizer()
        //   }
        // }, 30000)

        if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {

          if(currentSpeaker !== 'Candidate' || modeTitle !== 'Interview') {
            setRecognisedText((recognisedText) => {
              return getRecognisedText(recognisedText)
            })
          } else {
            setRecognisedTextYouSay((recognisedTextYouSay) => {
              return getRecognisedText(recognisedTextYouSay)
            })
          }
          function getRecognisedText (recognisedText) {
            let returnText = ''
            let fetchFuncParaStr = ''
            let tempText = `${e.result.text}`;
            const offset = Math.floor(e.result.offset / Math.pow(10, 7));
            const offsetHhMmSs = seconds_to_hhmmss(offset);
            if(modeTitle === 'Interview' || transcriber !== null) {
              tempText= `${offsetHhMmSs} ${e.result.text} \n`
            } 
            // console.log("tempText is:", tempText);
            // console.log('modeTitle is:', modeTitle);
            // console.log('currentSpeaker is:', currentSpeaker);
            // console.log('offsetHhMmSs is:',offsetHhMmSs);
            if (recognisedText === '') {
                returnText= `${tempText} \n`
            }
            else {
                returnText = `${recognisedText}${tempText} \n`
            }
            fetchFuncParaStr = `${e.result.text} `
            // console.log("callGptFunc running", countFetch+1)
            // let keywords = GPT_PRE_KEYWORDS[userDataLocal?.Language.code||'en-US'];
            let keywords = keywordsPreCallGpt;
            // console.log("prekeywords is:", keywords);

            countFetch++;
            if (countFetch === 2) {
              countFetch = 0
            } //保证对GPT的调用不重复

            for (let i = 0; i < keywords.length; i++) {
              if (fetchFuncParaStr.charAt(fetchFuncParaStr.length-2).toLowerCase() === keywords[i].toLowerCase()) {
                if (countFetch === 1) {
                  // console.log("\n    fetchFuncParaStr is:", fetchFuncParaStr)
                  // console.log("\n    prekeywords[i] is:", keywords[i])
                  if(currentSpeaker === 'Candidate') {
                    //not need callGpt
                  } else if (modeTitle === 'Interview' || modeTitle === 'Transcribe') {
                    callGptFunc(fetchFuncParaStr)
                  }
                  
                  break; // 找到关键词后退出循环
                }
              }
            }
            return returnText;
          }
          
          textRef.current.scrollTop = textRef.current.scrollHeight
        }
        else if (e.result.reason === sdk.ResultReason.NoMatch) {
          // console.log("NOMATCH: Speech could not be recognized.")
        }
      }

      recognizer.canceled = (s, e) => {
        // console.log(`CANCELED: Reason=${e.reason}`)

        if (e.reason === sdk.CancellationReason.Error) {
          console.log(`"CANCELED: ErrorCode=${e.errorCode}`)
          console.log(`"CANCELED: ErrorDetails=${e.errorDetails}`)
          console.log("CANCELED: Did you set the speech resource key and region values?")
        }
        recognizer.stopContinuousRecognitionAsync()
      }

      recognizer.sessionStopped = (s, e) => {
        // console.log("\n    Session stopped event.")
        recognizer.stopContinuousRecognitionAsync()
        clearTimeout(timeoutRef.current)
      }
    });
  }

  const seconds_to_hhmmss = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
    const seconds = totalSeconds - (hours * 3600) - (minutes * 60);
  
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  // this function will start a previously created speech recognizer
  const startRecognizer = () => {
    setIsRecognising(true);
      countFetch = 0
      if (recognizer && modeTitle !== 'Interview') {
        // recognizer.language = userDataLocal?.Language.code||'en-US';
        recognizer.startContinuousRecognitionAsync() 
        
      } else {
        // console.error('Recognizer is not initialized or already running.');
      }
      if(modeTitle === 'Interview' && transcriber) {
        startTranscribingAsync();
      } else {
        // console.error('Transcriber is not initialized or already running.');
      }
  }

  // this function will stop a running speech recognizer
  const stopRecognizer = () => {
    // console.log("stopRecognizer running")
    
    setIsRecognising(false)
    if (recognizer && modeTitle !== 'Interview')  {
      recognizer.stopContinuousRecognitionAsync();
      // console.log('Recognizer stopped.')
    } else {
      // console.log('Recognizer is not initialized or already stopped.');
    }
    if(modeTitle === 'Interview' && transcriber) {
      stopTranscribingAsync();
    }else {
      // console.log('Transcriber is not initialized or already stopped.');
    }
    clearTimeout(timeoutRef.current)
  }

  const callGptFunc = (returnTextData) => {
    if(callGptByKeywordstemp) {
      let transcriptionLc = returnTextData.toLowerCase();
      // let keywordsTwo = GPT_KEYWORDS[userDataLocal?.Language.code||'en-US']; // 从环境变量中获取关键词
      let keywordsTwo = keywordsCallGpt;
      // if(userDataLocal.Keywords  && userDataLocal.Keywords.length > 0) keywords.push(...userDataLocal.Keywords); // 将用户自定义的关键词数组添加到关键词数组中
      let keywordTwoFound = false; // 标记是否找到关键词

      // 检查是否包含任一关键词
      for (let i = 0; i < keywordsTwo.length; i++) {
          if (transcriptionLc.includes(keywordsTwo[i].toLowerCase())) {
              // console.log(`Found keyword: ${keywordsTwo[i]}`);
              stopRecognizer(); // 停止语音识别器
              keywordTwoFound = true;
              break; // 找到关键词后退出循环
          }
      }
      if (keywordTwoFound) {
        setRecognisingText("")
        setRecognisingTextYouSay("")
        setIsAIthinking(true)
        const gptVersion = (!userDataLocal || userDataLocal.GPTVersion==='GPT-3.5') ? 'gpt-3.5-turbo':userDataLocal.GPTVersion.toLowerCase();
        let customprompt = userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt;
        if(promptInput !== '') {
          customprompt = promptInput;
        }
        console.log("customprompt is:", customprompt);
        fetchAndReadStream(transcriptionLc, gptVersion, customprompt, stopBtnClicked);
        // console.log("gptVersion is:", gptVersion, "customprompt is:", customprompt)
     } 
    } else if(selectedText!=='') {
      setRecognisingText("")
      setRecognisingTextYouSay("")
      setIsAIthinking(true)
      const gptVersion = (!userDataLocal || userDataLocal.GPTVersion==='GPT-3.5') ? 'gpt-3.5-turbo':userDataLocal.GPTVersion.toLowerCase();
      let customprompt = userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt;
      if(promptInput !== '') {
        customprompt = promptInput;
      }
      console.log("customprompt is:", customprompt);
      fetchAndReadStream(returnTextData, gptVersion, customprompt, stopBtnClicked);
    }
    
  }

  // 定义一个函数来发送请求并处理流式响应 customprompt
  const fetchAndReadStream = (questionText, gptVersion, customprompt, stopBtnClicked) => {

    const url = `https://www.bingoai.net/chatgpt-clone?question=${encodeURIComponent(questionText)}&gptversion=${encodeURIComponent(gptVersion)}&customprompt=${encodeURIComponent(customprompt)}`;

    if (freshPageCount === 0) {
      setResponseText("");
      freshPageCount++;
    }// 初始化响应文本为空: 只有当刷新页面的时候才会重置两个文本框中的文本
    clearTimeout(timeoutRef.current);

    fetch(url, {
      method: 'POST', // 使用POST方法
      headers: {
        // 根据需要设置请求头
      },
    })
    .then(response => {
      if (!response.body) {
        throw new Error('ReadableStream not supported');
      }
      const reader = response.body.getReader();
      return new ReadableStream({
        start(controller) {
          function push() {
            reader.read().then(({ done, value }) => {
              if (done) {
                controller.close()
                setIsAIthinking(false)
                // console.log("before call startRecognizer, isRecognising is:", isRecognising? 'true':'false', "stopBtnClicked is:", stopBtnClicked? 'true':'false')
                if((!isRecognising)&&(!stopBtnClicked)) {
                  startRecognizer()
                  // console.log("startRecognizer running")
                }
                return
              }
              clearTimeout(timeoutRef.current);
              let chunk = new TextDecoder().decode(value);
              
              chunk = chunk.replace(/^data: /gm, '').replace(/\n/gm, '').replace(/<br\/>/gm, '\n').replace(/&nbsp;/gm, ' ').replace(/\[DONE\]/gm, '\n');
              setResponseText(prev => prev.replace(/^SpringAI thinking.../gm, '') + chunk); // 累加响应文本到状态变量
              controller.enqueue(value);
              push();
            });
          }
          push();
        }
      });
    })
    .catch(err => {
      setIsAIthinking(false)
      // freshPageCount = 0;
      // setErrorInfo('Network error. Please try again later.');
      // console.error('Fetch error:', err);
    });
  }

  //transcription text changed ——inputValue
  const handleInputChange = (e) => {
    // setRecognisedText(e.target.value);
    userTypingText = true;
    setInputValue(e.target.value);
  }

   //transcription text changed ——inputValueYouSay 2024.05.14
  const handleInputYouSayChange = (e) => {
    if(modeTitle === 'Interview') {
      userTypingTextYouSay = true;
      setInputValueYouSay(e.target.value);
    }
    // setRecognisedTextYouSay(e.target.value)
  }

  //2024.05.18 
  const handleMouseDown = (e) => {
    if(callGptByKeywords || isPaused)  return;
    if ( showSelectTextPopup ) setShowSelectTextPopup(false);
    setMouseDownLetInputValueSelectTextBeTop(true);
    setIsPaused(true);
  }

  const handleMouseDownInterviewee = (e) => {
    if(callGptByKeywords || isPaused) return;
    if ( showSelectTextIntervieweePopup ) setShowSelectTextIntervieweePopup(false);
    setMouseDownLetInputValueYouSaySelectTextBeTop(true);
    setIsPaused(true);
  }

  const handlePauseResume = () => {
    if(!isPaused) {
      setMouseDownLetInputValueSelectTextBeTop(true);
      setMouseDownLetInputValueYouSaySelectTextBeTop(true);
      setIsPaused(true);
    } else {
      setMouseDownLetInputValueSelectTextBeTop(false);
      setMouseDownLetInputValueYouSaySelectTextBeTop(false);
      setIsPaused(false);
    }
    
  }

  //2024.05.13 handleTextSelect
  const handleTextSelect = (e) => {
    if(callGptByKeywords) return;
    let selectedText = window.getSelection().toString();
    setSelectedText(selectedText);
    setShowSelectTextPopup(true);
    //thie timeout is to make sure before callGptFunc, the selectedText is updated
    if (selectedText.length > 0) {
      if(mousePosition.y !== 0) {
        setSelectTextPopupPosition({
          top: mousePosition.y - 100 + window.scrollY, 
          left: mousePosition.x - 280 + window.scrollX
        });
      }
      // console.log("SelectTextPopupPosition is:", selectTextPopupPosition);
      // setShowSelectTextPopup(true);
    } else {
      setSelectedText('');
      setShowSelectTextPopup(false);
      setMouseDownLetInputValueSelectTextBeTop(false);
      setMouseDownLetInputValueYouSaySelectTextBeTop(false);
      setIsPaused(false);
    }
  };

  const handleTextSelectInterviewee = (e) => {
    if(callGptByKeywords) return;
    let selectedText = window.getSelection().toString();
    setSelectedText(selectedText);
    setShowSelectTextIntervieweePopup(true);
    if (selectedText.length > 0) {
      if(mousePosition.y !== 0) {
        setSelectTextPopupPosition({
          top: mousePosition.y - 100 + window.scrollY, 
          left: mousePosition.x - 280 + window.scrollX
        });
      }
      // console.log("SelectTextPopupPosition is:", selectTextPopupPosition);
      // setShowSelectTextIntervieweePopup(true);
    } else {
      setSelectedText('');
      setShowSelectTextIntervieweePopup(false);
    }
  };

  const handleAskAI = () => {
    setShowSelectTextPopup(false);
    setShowSelectTextIntervieweePopup(false);
    callGptFunc(selectedText);
  };

  //2024.05.19 ask all text to AI
  const helpCallGPTAllText = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    askAll = true;
    if(!mouseDownLetInputValueSelectTextBeTop) {
      setSelectedText(inputValue);
    } else {
      setSelectedText(`${recognisedText}${recognisingText}`);
    }
  };

  const export2txt = (text1, text2) => {

    // if (textValueTempFlag) {
    //   text1 = inputValueTemp;
    //   text2 = inputValueYouSayTemp;
    // }
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }

    let combineText = text1;
    if (modeTitle === 'Interview' && text2 !== '') {
      combineText = combineTranscript(text1, text2);
    }
    const blob = new Blob([combineText], { type: "text/plain" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    const fileformat = 'transcript';
    link.download = `${nameSetbyTime(fileformat)}.txt` //"transcription.txt"  //`${nameSetbyTime()}.txt`
    link.href = url
    link.click()
    setSaveRecordClicked(true)
  } 

  const handleLoginClick = () => {
    // console.log("handleLoginClick running")
    // setShowLoginPopup(true);

    window.location.href = '/login';
  }

  function combineTranscript(inputValue, inputValueYouSay) {

    const parseLogs = (logs, name) => {
      return logs.split('\n').map(log => {
        const [time, ...message] = log.split(' ');
        return { time, message: message.join(' '), name };
      });
    };
  
    const Interviewertext = parseLogs(inputValue, 'Interviewer');
    const Candidatetext = parseLogs(inputValueYouSay, 'Candidate');
  
    const combinedLogs = [...Interviewertext, ...Candidatetext];
    combinedLogs.sort((a, b) => a.time.localeCompare(b.time));
    // return combinedLogs;
    return combinedLogs.join('\n');
  }

  //recording audio
  const startRecorder = () => {
    recorderControls.startRecording();
    // if(recorderControls.isRecording) {
    //   recorderControls.isRecording = false;
    //   recorderControls.mediaRecorder.stop();
    //   recorderControls.startRecording();
    // } else {
    //   recorderControls.startRecording();
    // }
    // if (isBlocked) {
    //   console.log('Permission Denied');
    // } else {
    //   Mp3Recorder
    //     .start()
    //     .then(() => {
    //       setIsRecording(true);
    //     }).catch((e) => console.error('Start error', e));
    // }
  };

  const stopRecorder = () => {
    // recorderControls.stopRecording();
    recorderControls.togglePauseResume();
    // Mp3Recorder
    //   .stop()
    //   .getMp3()
    //   .then(([buffer, blob]) => {
    //     const blobURL = URL.createObjectURL(blob);
    //     setBlobURL(blobURL);
    //     setIsRecording(false);
    //     if (mediaStreamRef.current) {
    //       mediaStreamRef.current.getTracks().forEach(track => track.stop());
    //     }
    //   }).catch((e) => console.error('Stop error', e));
  };

  const saveRecorder = () => {

    // if (audioBlob) {
    //   const url = URL.createObjectURL(audioBlob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   const fileformat = userDataLocal.AudioSet;
    //   const filename = nameSetbyTime(fileformat);
    //   console.log('Filename:', filename); // Debugging line
    //   console.log('File format:', fileformat); // Debugging line
    //   link.download = `${filename}.${fileformat}`; 
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(url); // Clean up
    // }

    recorderControls.stopRecording();
      // if (audioBlob) {
      //   if (userDataLocal.AudioSet==="wav"){
      //     saveRecording();
      //   } else {
      //     saveRecordingMp3();
      //   }
      // }

    // if (downloadLink.current && blobURL) {
    //   const date = new Date();
    //   const year = date.getFullYear();
    //   const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based in JavaScript
    //   const day = String(date.getDate()).padStart(2, '0');
    //   const hour = String(date.getHours()).padStart(2, '0');
    //   const minute = String(date.getMinutes()).padStart(2, '0');
    //   const filename = `recorded_${year}${month}${day}_${hour}${minute}.wav`;

    //   downloadLink.current.href = blobURL;
    //   downloadLink.current.download = filename;
    //   downloadLink.current.click();
    // }
  };

  const recorderControls = useAudioRecorder(
    {
      noiseSuppression: true,
      echoCancellation: true,
    },
    (err) => console.table(err) // onNotAllowedOrFound  
  );

  const handleRecordingComplete = (blob) => {
    const url = URL.createObjectURL(blob);
    setAudioBlob(blob);
    setBlobURL(url);
  };

  const addAudioElement = (blob) => {
    setAudioBlob(blob);
    const url = URL.createObjectURL(blob);
    const fileformat = userDataLocal.AudioSet;
    const audio = document.createElement(`${nameSetbyTime(fileformat)}`);
    audio.src = url;
    audio.controls = true;
    setBlobURL(url);
    // document.body.appendChild(audio);
  };

  // const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

  //save .wav file
  const saveRecording = async () => {
    if (audioBlob) {
      // Convert the audio blob to an AudioBuffer
      const arrayBuffer = await audioBlob.arrayBuffer();
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

      //By default, exports with 16-bit PCM (format: 1). You can specify opt.float32 instead, which will write format 3 with 32-bit float data.
      const wav = toWav(audioBuffer,48000);

      // Create a new blob from the WAV file
      const wavBlob = new Blob([new DataView(wav)], { type: 'audio/wav' });
  
      // Create a URL for the blob
      const url = URL.createObjectURL(wavBlob);
      const link = document.createElement('a');
      link.href = url;
      // link.download = `recording_${new Date().toISOString().replace(/:/g, '-')}.wav`; // Custom filename
      const fileformat = userDataLocal.AudioSet;
      link.download = `${nameSetbyTime(fileformat)}.wav`; // Custom filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    }
  };

  //save .mp3 file
  const saveRecordingMp3 = () => {
    if (audioBlob) {
      const url = URL.createObjectURL(audioBlob);
      const link = document.createElement('a');
      link.href = url;
      const fileformat = userDataLocal.AudioSet;
      link.download = `${nameSetbyTime(fileformat)}.mp3`; // Custom filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    }
  };

  const nameSetbyTime = (fileformat) => {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based in JavaScript
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      let filename;
      if(fileformat === 'transcript') {
        filename = `transcript_${year}${month}${day}_${hour}${minute}`;
      } else {
        filename = `recorder_${year}${month}${day}_${hour}${minute}`;
      }
      return filename;
  }

// click Avatar to go to the home page

  const handleClickonAvatar = () => {
      window.location.href = '/';
    };

  //2024.03.21 STT function
  const handleUpdateTextSTT = (newText) => {
    setRecognisingText(newText);
    textRef.current.scrollTop = textRef.current.scrollHeight
    // console.log("000 handleUpdateTextSTT running")
  };

  const handleUpdateRecognizedTextSTT = (transcriptionTxt) => {
    setRecognisingText('');
    setRecognisedText(transcriptionTxt);
    textRef.current.scrollTop = textRef.current.scrollHeight
    // console.log("111 handleUpdateRecognizedTextSTT running")
  }

  const handleStopSTT = () => {
    // console.log("222 Recognition stopped");
  };

  const handleStartSTT = () => {
    // Clear the recognisedText when starting a new transcription
    setRecognisedText('');
    setRecognisingText('');
    // console.log("333 handleStartSTT running");
    // setResponseText('');
  };

  //2024.03.28 Usage time limit
  // 检查并更新使用时长
  



  const handleAvatarClick = () => {
    setShowPopup(true)
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setShowFaqsPopup(false);
    setShowSTTPopup(false);
    setShowTTSPopup(false);
  }

  //onClose for PricePopup
  const handlePriceClosePopup = () => {
    confirmDisplayed = false;
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setShowFaqsPopup(false);
    setShowSTTPopup(false);
    setShowTTSPopup(false);
    // setShowTestOnePopup(false);
    // setShowTestTwoPopup(false);
  }

  //onClose for FaqsPopup
  const handleCloseFaqsPopup = () => {
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setShowFaqsPopup(false);
    setShowSTTPopup(false);
    setShowTTSPopup(false);
    // setShowTestOnePopup(false);
    // setShowTestTwoPopup(false);
  }

  //onClose for WavRecorder 2024.05.08
  const handleCloseWavRecorder = () => {
    setShowSoundSignatureWavrecorder(false);
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setShowFaqsPopup(false);
    setShowSTTPopup(false);
    setShowTTSPopup(false);
  }
  

  //2024.04.12 onClose for UserpagePopup
  const handleCloseUserpagePopup  = () => {
    setShowPopup(false);
  }

  const handleCloseSTTPopup = () => {
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setShowFaqsPopup(false);
    setShowSTTPopup(false);
    setShowTTSPopup(false);
  }

  const handleCloseTTSPopup = () => {
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setShowFaqsPopup(false);
    setShowSTTPopup(false);
    setShowTTSPopup(false);
  }

  //showHistory
  const showHistory = () => {

    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowHistoryPopup(true)
    setShowPopup(false)
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setShowFaqsPopup(false);
    setShowSTTPopup(false);
    setShowTTSPopup(false);
  }

  //showSettings
  const showSettings = () => {
    let userInput = prompt("Please enter the prompt content for GPT-40");
    setPromptInput(userInput);//promptInput, setPromptInput
  }

   //showUpgrade
   const showUpgrade = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowPricePopup(true);
    setShowSettingsPopup(false)
    setShowHistoryPopup(false)
    setShowPopup(false)
    setShowFaqsPopup(false);
    setShowSTTPopup(false);
    setShowTTSPopup(false);
  }

  //showFaqs
  
  const showFaqs = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowFaqsPopup(true);
    setShowPricePopup(false);
    setShowSettingsPopup(false)
    setShowHistoryPopup(false)
    setShowPopup(false)
    setShowSTTPopup(false);
    setShowTTSPopup(false);
  }

  const showSTT = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowSTTPopup(true);
    setShowFaqsPopup(false);
    setShowPricePopup(false);
    setShowSettingsPopup(false)
    setShowHistoryPopup(false)
    setShowPopup(false)
    setShowTTSPopup(false);
  }

  const showTTS = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowTTSPopup(true);
    setShowFaqsPopup(false);
    setShowPricePopup(false);
    setShowSettingsPopup(false)
    setShowHistoryPopup(false)
    setShowPopup(false)
    setShowSTTPopup(false);
    
  }

   //showTestOne showTestTwo
  //  const showTestOne = () => {
  //   setShowTestOnePopup(true)
  // }

  // const showTestTwo = () => {
  //   setShowTestTwoPopup(true)
  // }


  //settingpage save change call back
  const handleSaveChangeSettings = () => {
    setTimeout(() => {
      setShowSettingsPopup(false);
    }, 2);
  }

  //2024.03.30
  const handleSelectNote = (note) => {
    setSelectedNote(note);
  };

  const handleCloseDetail = () => {
    setSelectedNote(null);
    showHistory();
  };

  //2024.04.27
  const handleCongratulationsClosePopup = () => {
    setShowCongratulationsPopup(false);
  }


  //2024.04.12 confirm dialog
  const accept = () => {
    confirmDisplayed = false;
    // toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    setShowPricePopup(true);
  }

  const reject = () => {
    confirmDisplayed = false;
    setShowPricePopup(false);
    // console.log('reject upgrade');
      // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
  }

  const confirm = (tipText) => {
      confirmDialog({
          message: tipText,
          header: () => <div className='confirm-popup-title'>Upgrade Account</div>,
          onHide: reject(),
          className: 'confirm-popup-style',
          acceptClassName: 'confirm-popup-buttonOK',
          rejectClassName: 'confirm-popup-buttonCancel',
          accept,
          reject
      });
  };

  //2024.04.26 payment confirm popup
    const acceptpayment = () => {
      confirmDisplayed = false;
      setShowPricePopup(false);
      handlePriceClosePopup();
      // if(!isLoading && !isRecognising) {
        setLoadingText('Retrieving payment data...');
        setIsLoading(true);
        // console.log('accept upgrade, loading tip displayed');
      // }
      // toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    }
  
    const rejectpayment = () => {
      confirmDisplayed = false;
      setLoadingText('Done!');
          setIsLoading(false);

      // console.log('reject upgrade');
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }
  
    const confirmpayment = (tipTextpayment) => {
        confirmDialog({
            message: tipTextpayment,
            header: () => <div className='confirm-popup-title'>Confirmation</div>,
            onHide: rejectpayment(),
            className: 'confirm-popup-style',
            acceptClassName: 'confirm-popup-buttonOK',
            rejectClassName: 'confirm-popup-buttonCancel',
            rejectLabel: 'Failure',
            acceptLabel: 'Success',
            accept: acceptpayment,
            reject: rejectpayment,
        });
    };

    //2024.05.06 mode change

    const handleModeChange = (mode, event) => {


      // console.log("mode is:", mode)
      setInterfaceContentByModeChanged(mode);
      switch (mode) {
        case "Transcribe":
          break
        case "Interview":
          // setShowSoundSignatureWavrecorder(true);
          break
        case "STT":
          showSTT();
          break
        case "TTS":
          showTTS();
          break
        case "VoiceIntercom":
          break
         default:
            break
      }
    }

    const setInterfaceContentByModeChanged = (mode) => {
      setModeTitle(INTERFACE_CONTENT_TEXT[mode][0]); //AI changes everything, AI achieves everything
      setInterviewerTitle(INTERFACE_CONTENT_TEXT[mode][1]);
      setInterviewerTranscriptPlaceholdText(INTERFACE_CONTENT_TEXT[mode][2]);
      setAiResponseTitle(INTERFACE_CONTENT_TEXT[mode][3]);
      setAiResponsePlaceholdText(INTERFACE_CONTENT_TEXT[mode][4]);
      setIntervieweeTitle(INTERFACE_CONTENT_TEXT[mode][5]);
      setIntervieweeTranscriptPlaceholdText(INTERFACE_CONTENT_TEXT[mode][6]);
    }


    //2024.05.15 privilege check when user change AI lauanch mode(level===0 not allow to use selction launch AI)
    const selectOrKeywordsLanuchAI = (isKeywordsMode) => {
      if(!isLoggedIn) {
        setNeedLogin(true);
        return
      }
      if(!isKeywordsMode) { 

          setCallGptByKeywords(isKeywordsMode);

      } else {
        setCallGptByKeywords(isKeywordsMode)
      }
    }
    



    //2024.05.07 upgrade button title
    const resetUserInfo = () => {
      let MAX_USAGE;

        MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP2;

      

        if (userDataLocal.Usage.time >= 0 ) {
          let time = Math.floor(userDataLocal.Usage.time);
          setUsageStatus(`${time} of ${MAX_USAGE} monthly minutes used`);
          setUsageMax(MAX_USAGE);
          setUsageTime(time);
        } else {
          console.log('usage data error');
        }


      if (userDataLocal.VIPLevel > 0 && userDataLocal.VIPLevel <= 3){
        const date = new Date();
        date.setFullYear(date.getFullYear() + 100);
        const formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
        setExpireTime(formattedDate);
        if (userDataLocal.VIPLevel === 1){
            setVipLevelString('VIP');
            setUpgradeBtnTitle('Upgrade to Business');
          } else if (userDataLocal.VIPLevel === 2){
            setVipLevelString('Business VIP');
            setUpgradeBtnTitle('Renew payment');
          }
      } else {
        setVipLevelString('Free User');
      }
    };

    //2024.05.08 Voice Signature Audio save
    const handleSaveVoiceSignatureAudio = (waveRecoderAudioBlob, duration) => {
      if (duration < 30) {
        setToastMessage("The audio time is too short, which may lead to inaccurate speaker recognition. Please re-record.");
        setShowToast(true);
      } else {
        // console.log('audioBuffer duration:', duration)
        setAudioBlob(waveRecoderAudioBlob);
        const formData = new FormData();
        formData.append('audioFile', waveRecoderAudioBlob, 'recorded.wav');
        axios.post('/api/create-voicesignature', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },})
          .then(response => {
            setToastMessage('Voice Signature Successfully!' );
            // setVoiceSignatureStrings(response.data.voiceSignature);
            setVoiceSignatureStrings(prevVoiceSignatureStrings => [...prevVoiceSignatureStrings, response.data.voiceSignature]);
            setShowToast(true);
          })
          .catch(error => {
            // console.error('Network error:', error);
            setToastMessage('Network error, please try again later!' );
            setShowToast(true);
          });
        }
    }

  // ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————  
  //2024.05.09 ConversationTranscriber Test Code
  const createMeetingRecognizer = async (stream) => {
    // console.log("createMeetingRecognizer running");
    const config = await fetch('/api/speech-config').then(response => response.json());
    // 使用配置信息初始化 SpeechRecognizer
    var speechConfig = sdk.SpeechConfig.fromSubscription(config.subscriptionKey, config.serviceRegion);
    var audioConfig = sdk.AudioConfig.fromStreamInput(stream)
    speechConfig.speechRecognitionLanguage = [userDataLocal?.Language?.code||'en-US']; 

    if (transcriber) {
      transcriber.stopTranscribingAsync();
      transcriber.close();
      setTranscriber(null);
    }

    let transcriberNow = new sdk.ConversationTranscriber(speechConfig, audioConfig);
    setTranscriber(transcriberNow);
    transcriberNow.transcribing = function(s, e) {
      // console.log("(transcribing) text: " + e.result.text);
      // console.log("(transcribing) speakerId: " + e.result.speakerId);
      let spkiding = e.result.speakerId;

      // console.log("(transcribed) speakerId: " + spkid);

      if (spkiding === 'Guest-1'){
        spkiding = 'Candidate' 
      } else {
        spkiding = 'Interviewer'
        }
      setAudioDetected(true)
      if(spkiding !== 'Candidate') {
        setRecognisingText(e.result.text)
      } else {
        setRecognisingTextYouSay(e.result.text)
      }
      textRefYouSay.current.scrollTop = textRefYouSay.current.scrollHeight
      textRef.current.scrollTop = textRef.current.scrollHeight
    };

    transcriberNow.transcribed = function(s, e) {
      // console.log("(transcribed) text: " + e.result.text);
      // console.log("(transcribed) speakerId: " + e.result.speakerId);
      // let spkid = e.result.participantId
      let spkid = e.result.speakerId;

      // console.log("(transcribed) speakerId: " + spkid);

      if (spkid === 'Guest-1'){
        spkid = 'Candidate' 
        setCurrentSpeaker('Candidate')
      } else {
          spkid = 'Interviewer'
          setCurrentSpeaker('Interviewer')
        }
      console.log("spkid is:", spkid)
      console.log("transcribed:", e.result.text)
      setAudioDetected(false)
      setRecognisingText("")
      setRecognisingTextYouSay("")

      if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {

        if(spkid !== 'Candidate') {
          setRecognisedText((recognisedText) => {
            return getRecognisedText(recognisedText)
          })
        } else {
          setRecognisedTextYouSay((recognisedTextYouSay) => {
            return getRecognisedText(recognisedTextYouSay)
          })
        }
        function getRecognisedText (textValue) {
          let returnText = ''
          let fetchFuncParaStr = ''
          let tempText = `${e.result.text}`;
          const offset = Math.floor(e.result.offset / Math.pow(10, 7));
          const offsetHhMmSs = seconds_to_hhmmss(offset);
          if(modeTitle === 'Interview' || transcriber !== null) {
            tempText= `${offsetHhMmSs} ${e.result.text} \n`
          } 
          // console.log("tempText is:", tempText);
          // console.log('modeTitle is:', modeTitle);
          // console.log('currentSpeaker is:', currentSpeaker);
          // console.log('offsetHhMmSs is:',offsetHhMmSs);
          if (textValue === '') {
              returnText= tempText
          } else {
              returnText = `${textValue}${tempText} `
          }
          fetchFuncParaStr = `${e.result.text} `
          // console.log("callGptFunc running", countFetch+1)
          // let keywords = GPT_PRE_KEYWORDS[userDataLocal?.Language.code||'en-US'];
          let keywords = keywordsPreCallGpt;

          countFetch++;
          if (countFetch === 2) {
            countFetch = 0
          } //保证对GPT的调用不重复

          for (let i = 0; i < keywords.length; i++) {
            if (fetchFuncParaStr.charAt(fetchFuncParaStr.length-2).toLowerCase() === keywords[i].toLowerCase()) {
              if (countFetch === 1) {
                // console.log("\n    fetchFuncParaStr is:", fetchFuncParaStr)
                // console.log("\n    prekeywords[i] is:", keywords[i])
              if (modeTitle === 'Interview' || modeTitle === 'Transcribe') {
                  callGptFunc(fetchFuncParaStr)
                }
                
                break; // 找到关键词后退出循环
              }
            }
          }
          return returnText;
        }
        
        textRef.current.scrollTop = textRef.current.scrollHeight
        textRefYouSay.current.scrollTop = textRefYouSay.current.scrollHeight
      }
      else if (e.result.reason === sdk.ResultReason.NoMatch) {
        // console.log("NOMATCH: Speech could not be recognized.")
      }
    }

  }

  const stopTranscribingAsync = () => {
    if(transcriber) transcriber.stopTranscribingAsync();
  }

  const startTranscribingAsync = () => {
    if(transcriber) {
      transcriber.startTranscribingAsync(
        function () { },
        function (err) {
          console.trace("err - starting transcription: " + err);
          // Add error handling code here
        }
      )
    }
  }
// ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————


//2024.05.19 left panel subscription card(Left-menu panel hide/show function)
const handleToggleLeftPanel = () => {
  setIsLeftPanelVisible(!isLeftPanelVisible);
};

//2024.05.21 Transcript Panel panel toggle(Interveiwer panel hide/show function)
const handleToggleTranscriptPanel = () => {
  setIsTranscriptPanelVisible(!isTranscriptPanelVisible);
};


  return (

    <>

      <div className={isLeftPanelVisible ? "appstyle-body" : "appstyle-body-left-hide"}>

        <div className='appstyle-left-panel' style={{ display: isLeftPanelVisible ? 'block' : 'none' }}>
            <img src={logoSrc} alt="Logo" className="appstyle-logo-left" /> 
            <button className="appstyle-left-item" onClick={handleClickonAvatar} >
              <FontAwesomeIcon icon={faHome} className="appstyle-lighter-icon" /> 
              <span className="btn-text">
              Home&nbsp;&nbsp;</span>
            </button>

            <div className="appstyle-left-item">
                <FontAwesomeIcon icon={faToggleOn} className="appstyle-lighter-icon" /> <span className="btn-text">Mode:&nbsp;&nbsp;</span>
                <select name="mode" className="appstyle-mode-selector"
                  onChange={(event) => { 
                    handleModeChange(event.target.value, event);
                  }}>
                  <option value="Transcribe">{INTERFACE_CONTENT_TEXT['Transcribe'][0]}</option>
                  <option value="Interview">{INTERFACE_CONTENT_TEXT['Interview'][0]}</option>
                  <option value="STT">{INTERFACE_CONTENT_TEXT['STT'][0]}</option>
                  <option value="TTS">{INTERFACE_CONTENT_TEXT['TTS'][0]}</option>
                  <option value="VoiceIntercom">{INTERFACE_CONTENT_TEXT['VoiceIntercom'][0]}</option>
                </select>
            </div>
            <button className="appstyle-left-item" onClick={showSettings} >
              <FontAwesomeIcon icon={faCog} className="appstyle-lighter-icon" />
              <span className="btn-text"> Setting&nbsp;&nbsp;</span>
            </button>

            <button className="appstyle-left-item" onClick={showHistory} >
            <FontAwesomeIcon icon={faHistory} className="appstyle-lighter-icon" />
            <span className="btn-text"> History&nbsp;&nbsp;</span>
            </button>


            <button className="appstyle-left-item" onClick={showFaqs} >
              <FontAwesomeIcon icon={faQuestionCircle} className="appstyle-lighter-icon" />
              <span className="btn-text"> FAQs&nbsp;&nbsp;</span>
            </button>

            <div class="appstyle-subscription-card">
              <span className="btn-text"><hr style={{width: '100%'}} /></span>
              <div class="subscription-info">
                <div class="subscription-plan-container">
                  <span class="subscription-plan">{vipLevelString}</span>
                  <span class="validity-period">(Expire at: {expireTime})</span>
                </div>
                <span class="subscription-usage"> {usageStatus}</span>
                <progress value={usageTime} max={usageMax} class="progress-bar"></progress>
              </div>
              <button class="btn-upgrade" onClick={showUpgrade}>
                <FontAwesomeIcon icon={faLevelUpAlt} className="appstyle-btn-interspace" />
                <span className="btn-text">{upgradeBtnTitle}</span>
              </button>
            </div>
        </div>

        <div className="appstyle-right-panel" style={{ gridColumn: isLeftPanelVisible ? '2' : '1' }}>
            <div className="appstyle-header">
                {isLoading &&
                    <>
                      <div className="overlay"></div> 
                        <div className="apppage-loading-container">
                          <LoadingAnimation />
                          <div className="apppage-loading"> { loadingText }</div>
                        </div>
                    </>}

                    <Button  
                      onClick={handleToggleLeftPanel} 
                      className="appstyle-btn-outline-gray">
                      <FontAwesomeIcon icon={isLeftPanelVisible ? faChevronLeft : faChevronRight} className="appstyle-btn-interspace"/>
                    </Button>
                <div className="appstyle-title" style={{marginLeft: (modeTitle === 'Interview' || modeTitle === 'Transcribe') ? '7%' : '-10%'}}>{modeTitle}</div>

                {/* {modeTitle === 'Interview' && 
                  <Button  
                    onClick={() => setShowSoundSignatureWavrecorder(true)} 
                    className="appstyle-btn-outline">
                      <FontAwesomeIcon icon={faSignature} className="appstyle-btn-interspace"/>
                      <span className="btn-text"> Voice Signature </span>
                  </Button>} */}
                {(modeTitle === 'Interview' || modeTitle === 'Transcribe' )&& 
                  <Button  
                    onClick={() => selectOrKeywordsLanuchAI(true)} 
                    className={callGptByKeywords ? "appstyle-btn-outline":"appstyle-btn-outline-gray"}>
                    <FontAwesomeIcon icon={faKey} className="appstyle-btn-interspace"/> 
                    <span className="btn-text"> Launch AI by Keywords</span>
                  </Button>}
                {(modeTitle === 'Interview' || modeTitle === 'Transcribe' )&& 
                  <Button  
                    onClick={() => selectOrKeywordsLanuchAI(false)} 
                    className={callGptByKeywords ? "appstyle-btn-outline-gray":"appstyle-btn-outline"}>
                    <FontAwesomeIcon icon={faICursor} className="appstyle-btn-interspace"/> 
                    <span className="btn-text"> Launch AI by Selecting Text</span>
                  </Button>}


                {isLoggedIn ? (
                  <img src={ avatarNow } alt="Avatar" className="appstyle-avatarIndex" onClick={handleAvatarClick}/>
                  ) : (
                    <Button variant="primary" style={{ marginLeft: 'auto', marginRight: '10px'}} onClick={handleLoginClick} 
                    className='orange-button'>sign in</Button> 
                )}
            </div>

            <div className= {modeTitle === 'Interview' ? "appstyle-content" : "appstyle-content-rightpanle-hide"} 
              style={{gridTemplateAreas: isTranscriptPanelVisible ? 
              (modeTitle === 'Interview' ? 
              '"interviewer-title interviewee-title" "interviewer-speech interviewee-answer" "ai-title interviewee-answer" "ai-feedback interviewee-answer"' : 
              '"interviewer-title" "interviewer-speech" "ai-title" "ai-feedback"') : 
              (modeTitle === 'Interview' ? 
              '"ai-title interviewee-answer" "ai-feedback interviewee-answer"' : 
              '"ai-title" "ai-feedback"') , 
              gridTemplateRows: isTranscriptPanelVisible ? '0.3fr 4fr 0.3fr 4fr' : '0.2fr 5fr' }}>

                <div className="appstyle-interviewer-title" style={{ display: isTranscriptPanelVisible ? 'block' : 'none' }}>
                    <h2>{interviewerTitle}</h2>
                </div>
                <div className="appstyle-interviewer-speech" style={{ display: isTranscriptPanelVisible ? 'block' : 'none' }}>

                  <Form.Control as="textarea"
                    className='Form-control'
                    value={inputValue}
                    onChange={handleInputChange}
                    onMouseUp={handleTextSelect}
                    onMouseDown={handleMouseDown}
                    ref={textRef}
                    />

                  {showSelectTextPopup && (
                    <div
                      style={{
                        position: 'absolute',
                        top: `${selectTextPopupPosition.top}px`,
                        left: `${selectTextPopupPosition.left}px`,
                        zIndex: 100000
                      }}>
                      <Button variant="secondary"  className='appstyle-btn-selectbtn' onClick={handleAskAI}>Ask AI</Button>
                    </div>)}
                </div>

                <div className="appstyle-ai-title"  style={{borderRadius: isTranscriptPanelVisible ? '0':'10px 10px 0 0'}}>
                    <h2>{aiResponseTitle}</h2>
                    {modeTitle === 'Transcribe' && 
                      <Button  
                        onClick={handleToggleTranscriptPanel} 
                        className="appstyle-btn-outline-white">
                        <FontAwesomeIcon icon={isTranscriptPanelVisible ? faChevronUp : faChevronDown} className="appstyle-btn-interspace"/>
                      </Button>}

                    <Form.Text className="appstyle-text-muted">
                      {isAIthinking ? <span>Nvoice thinking<span className="dots"> </span></span> : ' '}
                    </Form.Text>
                </div>
                <div className="appstyle-ai-feedback">
                    
                    <Form.Control as="textarea"
                      value={responseText}
                      readOnly 
                      className='Form-control'
                      ref={responseTextRef}
                    />
                </div>
                

                <div className="appstyle-interviewee-title" style={{ display:(modeTitle === 'Interview') ? 'block' : 'none' }}>
                    <h2>{intervieweeTitle}</h2>
                </div>


                <div className="appstyle-interviewee-answer" style={{ display: (modeTitle === 'Interview') ? 'block' : 'none' }}>
                    <Form.Control as="textarea"
                      className='Form-control'
                      placeholder={intervieweeTranscriptPlaceholdText}
                      value={inputValueYouSay}
                      onChange={handleInputYouSayChange}
                      onMouseUp={handleTextSelectInterviewee}
                      onMouseDown={handleMouseDownInterviewee}
                      ref={textRefYouSay}
                    />

                    {showSelectTextIntervieweePopup && (
                      <div
                        style={{
                          position: 'absolute',
                          top: `${selectTextPopupPosition.top}px`,
                          left: `${selectTextPopupPosition.left}px`,
                          zIndex: 100000
                        }}>
                        <Button variant="secondary"  className='appstyle-btn-selectbtn' onClick={handleAskAI}>Ask AI</Button>
                      </div>)}
                </div>
            </div>

            <div className="appstyle-footer">
              <div className='appstyle-footer-left'>
              <Button variant={isRecognising ? "secondary" : "primary"} onClick={() => toggleListener()} className="appstyle-btn" ref={startStopRecordingRef} disabled={!isLoggedIn}>
                <FontAwesomeIcon icon={isRecognising ? faStop : faMicrophone}  className="appstyle-btn-interspace"/> 
                <span className="btn-text">
                {isRecognising 
                  ? ' Stop'
                  : ' Start'
                }
                </span>
              </Button>
              
              {isRecognising &&
              <Button  variant="secondary"  onClick={handlePauseResume} className="appstyle-btn">
                <FontAwesomeIcon icon={isPaused ? faPlay : faPause} className="appstyle-btn-interspace"/> 
                <span className="btn-text">
                  {isPaused ? ' Resume' : ' Pause'}
                </span>
              </Button>}

              {!callGptByKeywords &&
              <Button  variant="secondary"  onClick={helpCallGPTAllText} className="appstyle-btn">
                <FontAwesomeIcon icon={faLifeRing} className="appstyle-btn-interspace"/>
                <span className="btn-text"> Ask All</span>
              </Button>}

              <Button 
                variant="secondary" 
                onClick={() => export2txt(recognisedText, recognisedTextYouSay)} 
                className={`appstyle-btn ${(isRecognising || (recognisedText === "")) ? "appstyle-btngray" : ""}`} 
                disabled={isRecognising || recognisedText === "" }>
                <FontAwesomeIcon icon={faFileExport} className="appstyle-btn-interspace"/>
                <span className="btn-text"> Export</span>
              </Button>
              </div>
              <div className='appstyle-footer-right'>
                {isRecognising && 
                    <canvas ref={canvasRef} />}
              </div>
            </div>
        </div>
        {showPopup && <Userpage onClose={handleCloseUserpagePopup} showHistory={showHistory} showSettings={showSettings} showUpgrade={showUpgrade}/>} 
        {showHistoryPopup && <History isVisible={showHistoryPopup} onClose={() => setShowHistoryPopup(false)} onSelectNote={handleSelectNote}/>} 

        {showSettingsPopup && <SettingsPopup isVisible={showSettingsPopup} onClose={() => setShowSettingsPopup(false)} onSave={handleSaveChangeSettings}/>} 

        <ConfirmDialog />
        {showPricePopup && <PricePopup isVisible={showPricePopup} onClose={handlePriceClosePopup}/>}
        
        {showCongratulationsPopup &&
        <CongratulationsPopup isVisible={showCongratulationsPopup} onClose={handleCongratulationsClosePopup}/>}

        {showFaqsPopup && <FaqsPopup isVisible={showFaqsPopup} onClose={handleCloseFaqsPopup}/>}    

        {showSoundSignatureWavrecorder && <WavRecorder onClose={handleCloseWavRecorder} onSaveAudio={handleSaveVoiceSignatureAudio}/>}

        {selectedNote && (
          <Notedetail note={selectedNote} onClose={handleCloseDetail} />
          )}

        
        {!isRecognising && showTTSPopup  && <TextToSpeech isVisible={showTTSPopup} onClose={handleCloseTTSPopup}/>}


        {/* {stopBtnClicked &&  
          <div className='audio-control'>
            <audio src={blobURL} controls="controls" crossOrigin="anonymous" />
          </div>
        } */}

        <Toast className="custom-toast-container" onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
              <Toast.Body className='custom-toast-content'>{toastMessage}</Toast.Body>
        </Toast>

        <div hidden='true'>
          <AudioRecorder
            onRecordingComplete={(blob) =>addAudioElement(blob)}
            recorderControls={recorderControls}
            downloadOnSavePress={true} 
            downloadFileExtension={userDataLocal?.AudioSet || "mp3"}
            showVisualizer={false}
          />
        </div>
      </div>
    </>
  )
}

export default SuperuserTranscribeForever

